import { render, staticRenderFns } from "./TrialNotice.vue?vue&type=template&id=caa44354&"
import script from "./TrialNotice.vue?vue&type=script&lang=js&"
export * from "./TrialNotice.vue?vue&type=script&lang=js&"
import style0 from "./TrialNotice.vue?vue&type=style&index=0&id=caa44354&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports